"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class ContractModel extends _1.PipelineModel {
    constructor() {
        super(...arguments);
        this.instanceType = 'Contract';
    }
    static fromListing(listing) {
        const contract = new ContractModel();
        // Following line is to remain commented until Deal Sharing is revived
        // contract.systemCommis = true; // Setting this field to true prevents Salesforce from creating a new Commission for this record
        contract.commissionAmount = listing.commissionAmount;
        contract.listingId = listing._id;
        contract.name = listing.name;
        contract.ownerId = listing.ownerId;
        contract.propertyId = listing.propertyId;
        contract.pursuitId = listing.pursuitId;
        switch (listing.type) {
            default:// Default is treated as Seller Rep (PursuitModel.TYPES.SELLER_REPRESENTATION)
                contract.sellerCompanyId = listing.seller;
                contract.sellerContactId = listing.ownerContact;
                contract.type = this.TYPES.PENDING_SALE;
                break;
            case _1.PursuitModel.TYPES.BUYER_REPRESENTATION:
                contract.buyerCompanyId = listing.seller;
                contract.buyerContactId = listing.ownerContact;
                contract.type = this.TYPES.PENDING_SALE;
                break;
            case _1.PursuitModel.TYPES.LANDLORD_REPRESENTATION:
                contract.landlordCompanyId = listing.seller;
                contract.landlordContactId = listing.ownerContact;
                contract.type = this.TYPES.PENDING_LEASE;
                break;
            case _1.PursuitModel.TYPES.TENANT_REPRESENTATION:
                contract.tenantCompanyId = listing.seller;
                contract.tenantContactId = listing.ownerContact;
                contract.type = this.TYPES.PENDING_LEASE;
                break;
        }
        const acceptedOffer = listing.offers && listing.offers.find(offer => offer.status === _1.OfferModel.STATUS.ACCEPTED);
        if (acceptedOffer) {
            const offerPrice = acceptedOffer.offerPrice ? parseFloat(acceptedOffer.offerPrice) : null;
            contract.contractPrice = isNaN(offerPrice) ? 0 : offerPrice;
            contract.buyerContactId = acceptedOffer.purchaserId;
            contract.buyerCompanyId = acceptedOffer.purchaser && acceptedOffer.purchaser.companyId || null;
        }
        return contract;
    }
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            buyerAttorneyContactId: 'McLabs2__Buyer_s_Attorney__c',
            buyerCompanyId: 'McLabs2__Buyer_Company__c',
            buyerContactId: 'McLabs2__Buyer__c',
            buyerLoanContactId: 'McLabs2__Buyer_s_Loan_Contact__c',
            clientCompanyId: 'McLabs2__Client_Company__c',
            clientContactId: 'McLabs2__Client_Contact__c',
            commissionAmount: 'McLabs2__Escrow__c',
            contractCloseDate: 'McLabs2__Close_of_Escrow__c',
            contractPrice: 'McLabs2__Contract_Price__c',
            deposit: 'McLabs2__Earnest_Money_Deposit__c',
            effectiveDate: 'McLabs2__Effective_Date__c',
            landlordCompanyId: 'McLabs2__Landlord_Company__c',
            landlordContactId: 'McLabs2__Landlord__c',
            listingId: 'McLabs2__Listing__c',
            name: 'Name',
            probability: 'McLabs2__Probability__c',
            ownerId: 'OwnerId',
            propertyId: 'McLabs2__Property__c',
            pursuitId: 'McLabs2__Proposal__c',
            recordTypeId: 'RecordTypeId',
            sellerAttorneyContactId: 'McLabs2__Seller_s_Attorney__c',
            sellerCompanyId: 'McLabs2__Seller_Company__c',
            sellerContactId: 'McLabs2__Seller__c',
            status: 'McLabs2__Status__c',
            // systemCommis: 'McLabs2__System_Commis__c', // This line is to remain commented until Deal Sharing is revived
            tenantCompanyId: 'McLabs2__Tenant_Company__c',
            tenantContactId: 'McLabs2__Tenant__c',
            titleCompanyAttorneyContactId: 'McLabs2__Title_Company_Attorney__c'
        };
    }
    transformFromSalesforce(sfContract) {
        super.transformFromSalesforce(sfContract);
        this.type = sfContract.RecordType && sfContract.RecordType.Name;
        this.listingType = sfContract.McLabs2__Listing__r && sfContract.McLabs2__Listing__r.RecordType.Name;
    }
    get daysToClose() {
        let daysToClose;
        if (this.contractCloseDate) {
            daysToClose = Math.floor((new Date(this.contractCloseDate).getTime() - new Date().getTime()) / 86400000);
        }
        return daysToClose;
    }
    get price() {
        return this.contractPrice;
    }
    // clientContactId variable deleted; replaced with following getter
    // (Was formerly mapped to incorrect Salesforce field in salesforceFieldMap)
    get clientContactId() {
        if (_1.PursuitModel.TYPES.SELLER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.SELLER_REPRESENTATION) {
            return this.sellerContactId;
        }
        else if (_1.PursuitModel.TYPES.BUYER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.BUYER_REPRESENTATION) {
            return this.buyerContactId;
        }
        else if (_1.PursuitModel.TYPES.LANDLORD_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.LANDLORD_REPRESENTATION) {
            return this.landlordContactId;
        }
        else if (_1.PursuitModel.TYPES.TENANT_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.TENANT_REPRESENTATION) {
            return this.tenantContactId;
        }
        else {
            return this.sellerContactId;
        }
    }
    // clientContactId variable deleted; replaced with following setter
    // (Was formerly mapped to incorrect Salesforce field in salesforceFieldMap)
    set clientContactId(newId) {
        if (_1.PursuitModel.TYPES.SELLER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.SELLER_REPRESENTATION) {
            this.sellerContactId = newId;
        }
        else if (_1.PursuitModel.TYPES.BUYER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.BUYER_REPRESENTATION) {
            this.buyerContactId = newId;
        }
        else if (_1.PursuitModel.TYPES.LANDLORD_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.LANDLORD_REPRESENTATION) {
            this.landlordContactId = newId;
        }
        else if (_1.PursuitModel.TYPES.TENANT_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.TENANT_REPRESENTATION) {
            this.tenantContactId = newId;
        }
        else {
            this.sellerContactId = newId;
        }
    }
    // clientCompanyId variable deleted; replaced with following getter
    // (Was formerly mapped to incorrect Salesforce field in salesforceFieldMap)
    get clientCompanyId() {
        if (_1.PursuitModel.TYPES.SELLER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.SELLER_REPRESENTATION) {
            return this.sellerCompanyId;
        }
        else if (_1.PursuitModel.TYPES.BUYER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.BUYER_REPRESENTATION) {
            return this.buyerCompanyId;
        }
        else if (_1.PursuitModel.TYPES.LANDLORD_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.LANDLORD_REPRESENTATION) {
            return this.landlordCompanyId;
        }
        else if (_1.PursuitModel.TYPES.TENANT_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.TENANT_REPRESENTATION) {
            return this.tenantCompanyId;
        }
        else {
            return this.sellerCompanyId;
        }
    }
    // clientCompanyId variable deleted; replaced with following setter
    // (Was formerly mapped to incorrect Salesforce field in salesforceFieldMap)
    set clientCompanyId(newId) {
        if (_1.PursuitModel.TYPES.SELLER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.SELLER_REPRESENTATION) {
            this.sellerCompanyId = newId;
        }
        else if (_1.PursuitModel.TYPES.BUYER_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.BUYER_REPRESENTATION) {
            this.buyerCompanyId = newId;
        }
        else if (_1.PursuitModel.TYPES.LANDLORD_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.LANDLORD_REPRESENTATION) {
            this.landlordCompanyId = newId;
        }
        else if (_1.PursuitModel.TYPES.TENANT_REPRESENTATION && this.listingType === _1.PursuitModel.TYPES.TENANT_REPRESENTATION) {
            this.tenantCompanyId = newId;
        }
        else {
            this.sellerCompanyId = newId;
        }
    }
}
ContractModel.STATUSES = {
    CLOSED: 'Closed',
    DEAD: 'Dead',
    IN_CONTRACT: 'In Contract',
    PENDING: 'Pending'
};
ContractModel.TYPES = {
    PENDING_SALE: 'Pending Sale',
    PENDING_LEASE: 'Pending Lease'
};
exports.ContractModel = ContractModel;
//# sourceMappingURL=contract.model.js.map